<template>
  <div class="loader-background">
    <svg class="loader bl" viewBox="0 0 800 600" xmlns="http://www.w3.org/2000/svg" style="visibility: visible;">
      <defs>
        <linearGradient id="auroraGrad" x1="184" y1="300" x2="616" y2="300" gradientUnits="userSpaceOnUse">
          <stop class="auroraStops" offset="0" stop-color="#0194BC" style="stop-color: rgb(1, 148, 188);"></stop>
          <stop class="auroraStops" offset="0.5" stop-color="#1DA9CF" style="stop-color: rgb(29, 169, 207);"></stop>
          <stop class="auroraStops" offset="1" stop-color="#0FB3DE" style="stop-color: rgb(15, 179, 222);"></stop>
        </linearGradient>
        <linearGradient id="outlineGrad" x1="401.5" y1="78" x2="401.5" y2="522" gradientUnits="userSpaceOnUse">
          <stop offset="0" stop-color="#f2f2f2"></stop>
          <stop offset="1" stop-color="#e3e3e3"></stop>
        </linearGradient>
        <clipPath id="mountainMask">
          <circle class="mountainMask" cx="400" cy="300" r="200.51226549336312" fill="none"></circle>
        </clipPath>
        <linearGradient id="mountain1Grad" x1="109.55" y1="356.77" x2="533.94" y2="356.77" gradientUnits="userSpaceOnUse">
          <stop offset="0" stop-color="#f3f3f3"></stop>
          <stop offset="1" stop-color="#fcfcfc"></stop>
        </linearGradient>
        <linearGradient id="mountain2Grad" x1="287.46" y1="427.5" x2="676.6" y2="427.5" gradientUnits="userSpaceOnUse">
          <stop offset="0" stop-color="#fff"></stop>
          <stop offset="0.49" stop-color="#d5d5d5"></stop>
          <stop offset="1" stop-color="#fff"></stop>
        </linearGradient>
      </defs>
      <g class="mountainGroup">
        <circle class="outlineBg" cx="401.5" cy="300" r="214.6067503338255" fill="url(#outlineGrad)" stroke-miterlimit="0" stroke-width="0" stroke="none" opacity="0.5"></circle>
        <circle class="aurora" cx="400" cy="300" r="218.51226549336312" fill="url(#auroraGrad)"></circle>
        <g clip-path="url(#mountainMask)">
          <g class="mountains">
            <polygon points="481.6 273.5 726.79 660.77 237.5 660.77 481.6 273.5" fill="url(#mountain2Grad)" data-svg-origin="433.21599121093755 273.5" style="transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, -9.54687, 0, 0, 1); transform-origin: 0px 0px 0px;"></polygon>
            <polygon points="330.95 202.27 573.58 621.12 86.77 621.12 330.95 202.27" fill="url(#mountain1Grad)" data-svg-origin="378.8560134887695 202.27000427246094" style="transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, -9.18288, 0, 0, 1); transform-origin: 0px 0px 0px;"></polygon>
          </g>
          <g class="mountains" transform="translate(372 0)">
            <polygon points="481.6 273.5 726.79 660.77 237.5 660.77 481.6 273.5" fill="url(#mountain2Grad)" data-svg-origin="433.21599121093755 273.5" style="transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, -9.02389, 0, 0, 1); transform-origin: 0px 0px 0px;"></polygon>
            <polygon points="330.95 202.27 573.58 621.12 86.77 621.12 330.95 202.27" fill="url(#mountain1Grad)" data-svg-origin="378.8560134887695 202.27000427246094" style="transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, -0.35056, 0, 0, 1); transform-origin: 0px 0px 0px;"></polygon>
          </g>
        </g>
        <circle class="outline" cx="401.5" cy="300" r="218.51226549336312" fill="none" stroke-miterlimit="5" stroke-width="0" stroke="url(#outlineGrad)"></circle></g>
      </g>
    </svg>
  </div>
</template>

<script>
  import { TimelineMax, TweenMax } from 'gsap';

  export default {
    mounted() {
      const auroraStops = this.$el.querySelectorAll('.auroraStops');
      const auroraColors = ['#0194BC', '#1DA9CF', '#0FB3DE'];
      const outline = this.$el.querySelector('.outline');
      const aurora = this.$el.querySelector('.aurora');
      const mountainMask = this.$el.querySelector('.mountainMask');
      const mountains = this.$el.querySelectorAll('.mountains *');
      const outlineBg = this.$el.querySelector('.outlineBg');
      const mainTimeline = new TimelineMax({});
      const auroraTimeline = new TimelineMax({ repeat: -1 });
      const mountainTimeline = new TimelineMax({ repeat: -1, repeatDelay: 0 });

      const is_iPad = navigator.userAgent.match(/iPad/i) != null;
      const is_Safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
      const is_IE11 = navigator.userAgent.match(/Trident\/7\./) != null;

      if (!is_iPad) {
        auroraTimeline
          .staggerTo(
            auroraStops,
            0.42,
            {
              cycle: {
                stopColor: [auroraColors[1], auroraColors[2], auroraColors[0]],
              },
              ease: Sine.easeInOut,
            },
            0
          )
          .staggerTo(
            auroraStops,
            0.42,
            {
              cycle: {
                stopColor: [auroraColors[2], auroraColors[0],auroraColors[1]]
              },
              ease: Sine.easeInOut,
            },
            0
          )
          .staggerTo(
            auroraStops,
            0.42,
            {
              cycle: {
                stopColor: [auroraColors[0], auroraColors[1],auroraColors[2]]
              },
              ease: Sine.easeInOut
            },
            0
          );

        // Give Safari and IE a simplified version
        if (is_Safari || is_IE11){
          mountainTimeline
          .to(
            [outline, aurora, mountainMask],
            1.5,
            {
              attr: {
                r: '-=190',
              },
              ease: Elastic.easeIn.config(0.61, 0.8),
              repeat: 1,
              yoyo: true,
            }
          )
          .to(
            outlineBg,
            1.5,
            {
              attr: {
                r: '+=20',
              },
              repeat: 1,
              yoyo: true,
              ease: Elastic.easeIn.config(0.91, 0.48)
            },
            '-=' + mountainTimeline.recent().duration()
          );
        }else{
          mountainTimeline
          .to(
            [outline, aurora, mountainMask],
            1.5,
            {
              attr: {
                r: '-=190',
              },
              ease: Elastic.easeIn.config(0.61, 0.8),
              repeat: 1,
              yoyo: true,
            }
          )
          .staggerTo(
            mountains,
            2.75,
            {
              cycle: {
                transformOrigin:['60% 0%', '40% 0%'],
                x: [-380],
              },
              ease: Expo.easeInOut,
            },
            0.1,
            '-=3'
          )
          .to(
            outlineBg,
            1.5,
            {
              attr: {
                r: '+=20',
              },
              repeat: 1,
              yoyo: true,
              ease: Elastic.easeIn.config(0.91, 0.48)
            },
            '-=' + mountainTimeline.recent().duration()
          );
        }
      }
    },
  };
</script>
